import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3f757860/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Color`}</h2>
    <p>{`Refer to the `}<a parentName="p" {...{
        "href": "/components/button/style"
      }}>{`button`}</a>{` for primary and secondary button styling in the transactional modal.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Color token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-container`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`background-color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ui-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-02`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close__icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fill`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$icon-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close:hover`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`background-color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$hover-ui`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Overlay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$overlay-01`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Typography`}</h2>
    <p>{`Modal titles and labels should be set in sentence case. Keep all titles and labels concise and to the point. Modal labels are optional.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Font-size (px/rem)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Font-weight`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12 / 0.75`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$label-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20 / 1.25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$heading-03`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14 / 0.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$body-long-01`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Structure`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px / rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Spacing token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`height, width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48 x 48`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close__icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`height, width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 x 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 / 0.25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-02`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding top, padding left`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding-left`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding-right`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48 / 3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-09`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.96428571428572%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABAklEQVQY032OsU7DMBRF7fZbGNgYGBhBYmSh/RoGfqMZWPgDqFRAZOvGQiUqIRXSFJo2sWP7GTtSKoKKjJ0oZWlzpat3n3109RCqdXmBkuIbuzj4nB0+LaOrESHeWAhvorX3lmXlfNWq9zJfXj/PogPHjhYxRltlC6MFb7sYfrAuizMDwA0IMD9FUfp3vTa1QKmOY6XS7Z2FQVoVjhPaDVMwASEbvyeJmVJqaJ6b3BbOlTp3bKQbCoerVcvF3jQ4uRf8wQe4eQS49aWsbPc7zvsDzv0+Y0eOtbOFdur0uJr7ew3Qv+yhDb/2wlKdsw08iWNMuMApSMzkFw4Jxe699rbSPwe7wy/EigCUAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Structure and spacing measurements for a passive modal",
            "title": "Structure and spacing measurements for a passive modal",
            "src": "/static/19e597485d93fec5473bf9689bade75c/3cbba/modal-style-1.png",
            "srcSet": ["/static/19e597485d93fec5473bf9689bade75c/7fc1e/modal-style-1.png 288w", "/static/19e597485d93fec5473bf9689bade75c/a5df1/modal-style-1.png 576w", "/static/19e597485d93fec5473bf9689bade75c/3cbba/modal-style-1.png 1152w", "/static/19e597485d93fec5473bf9689bade75c/0b124/modal-style-1.png 1728w", "/static/19e597485d93fec5473bf9689bade75c/99571/modal-style-1.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">
  Structure and spacing measurements for a passive modal | px / rem
    </Caption>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.357142857142854%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABiElEQVQoz41SwUrDQBDd2qvgSQTxYmu1CiKK31CqtoItTa0tqD9hVerF37HePOnFi6IWvenRJJtEjU22SUqahGY7ZuNNG3HgMQPzeLw3DEI/CgDQf+tClv/Ynhyha9OIsfH0sZVq8q97V29vHMOlonA3psndmgZ3qaqVc4z3mxKeYtygxyIFeUWLs/GZV4u8oIGgSCAqSoi2YYBp22D3++AGMURd32JciZB4pEn5Qw2XitrOY1ECCYs+FgRfwpiKgkCxIPqEEN9xHGhbnU3G1SwjWvC98+3w09TzPdeBXq9HXdelnucNPM8deK5DGSj1QZKNUPD9w4qzdEMjv9gwEh4ba1zL6sKdrtN7QgYPIazBXadL7w0rgANnLRIKNp+0eOQNq+V6uKzsnBQK1V3IFosBtmCtVIPVug3JQ4CZAx9SDYBEwygzbvo4MDHUYVBz6YnvnhwbX15IZxdn5zJLqURmfn4lE9vurKNKfwNVunlU7udQTZ8MySVAkZFZTSdG//2HKPf7Z78Asq36u8HrbFAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Structure and spacing measurements for a transactional modal",
            "title": "Structure and spacing measurements for a transactional modal",
            "src": "/static/9b938ec94a5bef1b714dd6c59bfa3677/3cbba/modal-style-2.png",
            "srcSet": ["/static/9b938ec94a5bef1b714dd6c59bfa3677/7fc1e/modal-style-2.png 288w", "/static/9b938ec94a5bef1b714dd6c59bfa3677/a5df1/modal-style-2.png 576w", "/static/9b938ec94a5bef1b714dd6c59bfa3677/3cbba/modal-style-2.png 1152w", "/static/9b938ec94a5bef1b714dd6c59bfa3677/0b124/modal-style-2.png 1728w", "/static/9b938ec94a5bef1b714dd6c59bfa3677/99571/modal-style-2.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">
  Structure and spacing measurements for a transactional modal | px / rem
    </Caption>
    <h3>{`Margin-right`}</h3>
    <p>{`Modals that are 36% width and larger have a `}<inlineCode parentName="p">{`margin-right: 20%`}</inlineCode>{` (margin percentage is based off the width of the modal window). If the modal is smaller than 36% then it has a fixed `}<inlineCode parentName="p">{`margin-right: 16px/1rem`}</inlineCode>{`. Body copy, including titles, in a modal alway follows the 20% margin-right rule. However, inputs and other components may still expanded the full width of modal window.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.96428571428572%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABW0lEQVQY04WRy0rDQBSGk9aVuLAgbvWlunXpC/ggorQEhFIQK6gQSxG8QDduFaEUuokxaS5tJ5lkmpm2Nknp8UyhRXDhDz+c23xnhlEU1IfvHw2Gw7rv+5UgDKt5mmpekpzVLask+1cB2e4NBqchIReMMU0Ioc1mM22OJpxX24xdPlJaVtZ699ybLM9hNBpBFEWAg+CNx3AXkEPZb8RxqWPbS4G1MAwBYZBlGSzQfLGAHgA8x7G2Ab45TkNMJuA4DnieBzGlYBKy1Ck9kP1rFu92HSdluEwulR6iA7Qfx9BF4AtjlQ2wQ+lJIkR7Opno+Jwm3rDlcq7XnP6+7J9bXztGFN1OhWglnN9zzptyDvOmz5j+FEWvD5Qer2AIV5S9naLyV6sasHGxXK8VMCwo/2jF+p10DEO1+n0VvuebumGaW5Dmqow5Iapp26rruip+oDrwPPUTY3l2DfsBa28ZbdsM4ooAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Margin-right for modals less than 36% and greater than 36%",
            "title": "Margin-right for modals less than 36% and greater than 36%",
            "src": "/static/6e1e9661f499f90cec3f954445828003/3cbba/modal-style-3.png",
            "srcSet": ["/static/6e1e9661f499f90cec3f954445828003/7fc1e/modal-style-3.png 288w", "/static/6e1e9661f499f90cec3f954445828003/a5df1/modal-style-3.png 576w", "/static/6e1e9661f499f90cec3f954445828003/3cbba/modal-style-3.png 1152w", "/static/6e1e9661f499f90cec3f954445828003/0b124/modal-style-3.png 1728w", "/static/6e1e9661f499f90cec3f954445828003/99571/modal-style-3.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">
  Margin-right for modals less than 36% (left) and greater than 36% (right).
    </Caption>
    {
      /*
      ### Buttons widths
      | Number of buttons    | Percentage of modal     | Positioning    |
      | -------------------- | ----------------------- | -------------- | 
      | 1                    | 50%                     | Flush right    |
      | 2                    | 50% each                | Full bleed     |
      | 3                    | 25% each                | Flush right    |
      */
    }
    <h2>{`Sizes`}</h2>
    <p>{`There are four modal sizes: `}<strong parentName="p">{`xs, small, default, large`}</strong>{`. Each modal size has a responsive width that changes based on the browser size. As the browser decreases, the modal width percentage increases thus maintaining a proper ratio between the modal and browser. Modal widths are defined as percentages of the browser but will still align to columns on the 2x grid.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.90760869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACMklEQVQ4y41TW4vaYBDd/1wKXcF7tUZXBas1sfESTbRSFlu1ilvfCkWFQqHbeqk1brJ9sPpQUKuCeppJMO4u28vAQPLlzJmTOfOdQIv9fq/nIQ7vN/M+3F0sxYmqqhBFEYVCAdlsFhkhazwLAlqtllm02WxQLpd1bC6XQzojaHgRkiShVCphtVoZhL1eDx6PB16vFxeNBr58+oBwKASHw4Fa7Y2phApYloXT6cTbZhOK/BXv3zXhcrkQi8WwWCwMwsFgAH8ggFAwCD4lgH0lIxzh4HviQUNrcJMwmUyC8fuRTnJIvf6MyPkVAowHHJfAcrk0CPv9Pnw+H4LBM9jsdjy0BhA4C+mq6/X6LcJEIgGGYWC3WfHg9DEsrqfwMz7E43EsDoQkdTQaQZZlKIqCa0XGeCzjm3Y2nU7NGe52O9C8CasoKq7VMdSrEUZanarVbbdbgxD/CCKivOvun7C6wuFwCJplt9vVk8ZA75PJxFRICsbjMchEygOWks5NhfSRHI1EIvpK5AsvkE5nYLPZUK1Wze7UmNykpPXKZnPIiRJ4zahn2gxNU0id2+1Gu902i6eT78YaXVyYZ/P5XG84m81u/eZq+RP5vHRcG1JIhIzmFuMP4BF7CQv7EU67VVN43ENSEI1G9RULBxm4YzVYhB845S4RjfP4tVwcb0qxWNS7J1Mp8JkiMuK53rXT6ZiE6/UalUoFPM9r+8jjeVoCJ5TApV+iojXebNb/5/J99/dv2N9fTYPXgnTJfgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Modal sizes",
            "title": "Modal sizes",
            "src": "/static/8624364fd9e1199bf1cb42140170ef54/3cbba/modal-usage-sizes.png",
            "srcSet": ["/static/8624364fd9e1199bf1cb42140170ef54/7fc1e/modal-usage-sizes.png 288w", "/static/8624364fd9e1199bf1cb42140170ef54/a5df1/modal-usage-sizes.png 576w", "/static/8624364fd9e1199bf1cb42140170ef54/3cbba/modal-usage-sizes.png 1152w", "/static/8624364fd9e1199bf1cb42140170ef54/392b1/modal-usage-sizes.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <h3>{`XS`}</h3>
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Breakpoint`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Percentage width`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Column span`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin-right`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1584`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`24%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1312`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`24%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1056`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`32%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`5 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`672`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`48%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 8`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`320`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`100%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
          </tbody>
        </table>
        <h3>{`Small`}</h3>
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Breakpoint`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Percentage width`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Column span`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin-right`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1584`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`36%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`6 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1312`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`36%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`6 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1056`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`42%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`7 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`672`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`60%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`5 of 8`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`320`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`100%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
          </tbody>
        </table>
        <h3>{`Default`}</h3>
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Breakpoint`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Percentage width`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Column span`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin-right`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1584`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`48%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`8 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1312`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`48%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`8 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1056`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`60%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`10 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`672`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`84%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`7 of 8`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`320`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`100%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
          </tbody>
        </table>
        <h3>{`Large`}</h3>
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Breakpoint`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Percentage width`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Column span`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin-right`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1584`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`72%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`12 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1312`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`72%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`12 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`1056`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`84%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`14 of 16`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`672`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`96%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`8 of 8`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`20%`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`320`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`100%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4 of 4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`16px / 1rem`}</td>
            </tr>
          </tbody>
        </table>
        <h3>{`Max sizes`}</h3>
        <p>{`Each modal size has a max height and width in order to maintain a proper window ratio.`}</p>
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Modal size`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Max-height`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Max-width`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`XS`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`48%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`420px`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`Small`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`72%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`576px`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`Default`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`84%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`768px`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`Large`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`96%`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`–`}</td>
            </tr>
          </tbody>
        </table>
      </Column>
    </Row>
    <h3>{`Mobile`}</h3>
    <p>{`On mobile devices, at the smaller break points the max-height does not apply. The height may either be 100% of the screen or maintain the height defined by the content while sticking to the bottom of the mobile screen.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.53804347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAC4ElEQVQ4y42TX0hTURzHr1zcYDqz/XFtE1lEQfSkCd6Cymmbg2GKL8Zc0jJWthejIiv2Is5/CP6d6EsQyJjMXDbIIfggwhw9zITQZ1ETyv3RbXe73q1f5xzLpMC68OX8zv3+7uee8zvnR1H/8ezs7Ag2NzdF/0jL+fOFAqkV6dExKbGxsLAgDIVCeTgWi8WFQqHwMdJzpGcCgeAVGi9iLzc3N4fS6/U0nlRVVTVZLBZobm4mamlpgdra2jvYc7vdIgQV47isrOwKyoXq6mrQarVgMBiAYRg79nQ6HY2TCXBiYsK0t7cH8XicSyQSaZZlwefzNWFvdXVVFAwGCdBkMlX09PTAyMgINzg4mB4bGwObzdaOvaGhIZqanJwkwNHRUVM4HAakTCQS4aPRKHg8HgJE2xUtLy8TYGNjI9PZ2Qn9/f3Zvr4+fnh4GKxW6wvs9fb20pTL5SJA9CcTWhkkk8lMKpXi0QjT09PmX8BAIECADQ0NjN1uB4fDke3o6OARFFCpCBDNfwOdTucRkGUxkAXPMSASAba1tTFerxfm5+ezH+bm+KWlJejq6ibAOb//byASArJkhWjLR8C1tTUCRLVjtra2YH9/Pxve/cYDfAff+1kCZJMJmpqamiLA8fFxUzqdBo7jMgcHHM9xafDOzJAaflpZOQIODAxUbGxsQCwWy3zdjfJphHw7844cSiQWpymj0UgfHnlNU+tDKzywPeFuOcIpYzcLV++6yQrfzIZEi4uLBHj9hpYxm81guXefr2n/zN10AJSbXS+xp7WHaUomkxGgTCa/LZNJQa5QQkHJNcgrqYQCVamJXAfna5Hf78/HcVGRolwqRXlyORQWl0K+moFTyktPsZevvExTKpWKtIlKpTytVKnqitXK+rNFOfUaKVV3TkFJsPcxGBCur6+T1rtw/rwQfVOpVqv1GoVQp5FRBo2ckmNPI//ZcxKJ5MQm3d7+IkB1O7GXz4gPxx9tsHgNPBsLFQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Modal sizes",
            "title": "Modal sizes",
            "src": "/static/68be41ffcfb0e54c5aeae79bd9544be1/3cbba/modal-style-4.png",
            "srcSet": ["/static/68be41ffcfb0e54c5aeae79bd9544be1/7fc1e/modal-style-4.png 288w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/a5df1/modal-style-4.png 576w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/3cbba/modal-style-4.png 1152w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/392b1/modal-style-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      